import "./Contact.css";
import arrow from "../../Images/Icons/arrowdownwhite.png";
import rightArrow from "../../Images/Icons/rightArrow.png";
import { Social, Footer, Nav } from "../../Components/ExportComponents";
import { useState } from "react";
import { Helmet } from "react-helmet"; // ✅ added Helmet

const Contact = () => {
  const [menuBar, setMenuBar] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required";
    if (!email.trim()) newErrors.email = "Email is required";
    if (!message.trim()) newErrors.message = "Message is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    setIsSending(true);
    setSuccessMessage("");

    try {
      const response = await fetch(
        "http://localhost:5000/api/thevisualdesigner/message",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Name: name, Email: email, Message: message }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage("Message sent successfully!");
        setName("");
        setEmail("");
        setMessage("");
        setIsSent(true);
      } else {
        setSuccessMessage(data.error || "Could not send the message!");
      }
    } catch (error) {
      console.error(error);
      setSuccessMessage("Could not send the message!");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="backgroundBig">
      {/* ✅ Page-specific SEO */}
      <Helmet>
        <title>Contact Graphic Designer in Pokhara, Nepal | The Visual Designer</title>
        <meta name="description" content="Contact The Visual Designer for graphic design, UI/UX design, branding, logo design, and digital marketing services in Nepal and worldwide." />

        {/* Open Graph */}
        <meta property="og:title" content="Contact Graphic Designer in Pokhara, Nepal | The Visual Designer" />
        <meta property="og:description" content="Contact The Visual Designer for graphic design, UI/UX design, branding, logo design, and digital marketing services in Nepal and worldwide." />
        <meta property="og:image" content="https://thevisualdesigner.co/static/media/AuthorHero.cd911b13e8eeef5efb43.png" />
        <meta property="og:url" content="https://thevisualdesigner.co/contact" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Graphic Designer in Pokhara, Nepal | The Visual Designer" />
        <meta name="twitter:description" content="Contact The Visual Designer for graphic design, UI/UX design, branding, logo design, and digital marketing services in Nepal and worldwide." />
        <meta name="twitter:image" content="https://thevisualdesigner.co/static/media/AuthorHero.cd911b13e8eeef5efb43.png" />

        {/* Canonical */}
        <link rel="canonical" href="https://thevisualdesigner.co/contact" />
      </Helmet>

      <span className="mainBackgroundHR"></span>
      <span className="mainBackgroundHRleft"></span>
      <div className="mainBackgroundHRRight"></div>
      <span className="mainBackgroundHRright"></span>
      <span className="mainBackgroundBig"></span>
      <span className="mainBackgroundBigRight"></span>

      <div className="smallBack">
        <div className="topLeftInternal"></div>
        <div className="topLeftInternal2"></div>

        <div className="topRightInternal"></div>
        <div className="topRightInternal2"></div>
        <Nav setMenuBar={setMenuBar} menuBar={menuBar} />

        <div className="contactPage">
          <div className="contactBox">
            <div className="textIntroContact">
              <div className="headlineContact">Let’s Talk,</div>
              <div className="descContact">
                Let’s collaborate! Reach out to discuss your next project today.
              </div>
            </div>

            <div className="nameNemail">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={errors.name || "Name"}
                className={errors.name ? "errorInput" : ""}
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={errors.email || "Email"}
                className={errors.email ? "errorInput" : ""}
              />
            </div>

            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder={errors.message || "Message"}
              className={errors.message ? "errorInput" : ""}
            ></textarea>

            <button
              type="button"
              onClick={handleSubmit}
              disabled={isSending || isSent}
              style={{ cursor: isSending || isSent ? "not-allowed" : "pointer" }}
            >
              <div className="btnBackground"></div>
              <div className="textSend">
                {isSending ? "Sending..." : isSent ? "Sent" : "Send"}
              </div>
              <div className="iconSend">
                <img src={arrow} alt="Send message icon – The Visual Designer" />
                <img src={rightArrow} alt="Arrow icon for contact form submission" />
              </div>
            </button>

            {successMessage && (
              <div
                style={{
                  marginTop: "15px",
                  color: successMessage.includes("successfully") ? "green" : "red",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {successMessage}
              </div>
            )}
          </div>
        </div>
      </div>

      <Social />
      <Footer />
    </div>
  );
};

export default Contact;
